function PartitaIva(partitaiva) {
    this.partitaiva = partitaiva;
    this.cfReg = /^[0-9]{11}$/;
}

PartitaIva.prototype.isValid = function () {
    if (this.partitaiva == "") {
        return false;
    }

    if (!this.cfReg.test(this.partitaiva)) {
        return false;
    }

    return true;
}